import React, { useState } from 'react';
import * as Sentry from '@sentry/react';
import { ErrorBoundary } from 'react-error-boundary';
import 'bootstrap/dist/css/bootstrap.css';
import ErrorFallback from './ErrorFallback';

const GlobalErrorBoundary = function (props: React.PropsWithChildren<{}>) {
  const [eventId, setEventId] = useState<string | undefined>(undefined);

  return (
    <ErrorBoundary
      onError={(error, errorInfo) => {
        setEventId(
          Sentry.withScope((scope) => {
            scope.setLevel('fatal');
            scope.setTag('errorBoundary', 'global');
            scope.setContext('react', { componentStack: errorInfo.componentStack });
            return Sentry.captureException(error);
          })
        );
      }}
      fallbackRender={({ error }) => <ErrorFallback error={error} eventId={eventId} />}
    >
      {props.children}
    </ErrorBoundary>
  );
};

export default GlobalErrorBoundary;
